export const GET_SKILLS = "GET_SKILLS";
export const SEARCH_SKILLS = "SEARCH_SKILLS";
export const SKILL_SAVE_PRIOLITY = "SKILL_SAVE_PRIOLITY";
export const GET_SKILLS_BY_TYPE = "GET_SKILLS_BY_TYPE";